import VueCompositionAPI from "@vue/composition-api";
import PortalVue from "portal-vue";
import Vue from "vue";
import VueScreen from "vue-screen";
import VueZoomer from "vue-zoomer";
import { useOverride } from "@/lib/i18nHelpers";
import i18n from "@/modules/i18n";
import customDirectives from "@/directives";
import { setup } from "./modules/logger";
import router from "./router";
import routerHooks from "./router/globalHooks";
import store from "./store";

useOverride();
Vue.config.performance = process.env.NODE_ENV === "development";

export function getApp() {
  Vue.use(VueCompositionAPI);
  Vue.use(routerHooks, { router, store });
  Vue.use(setup, { store });
  Vue.use(PortalVue);
  Vue.use(VueZoomer);
  Vue.use(customDirectives);
  Vue.use(VueScreen, {
    mobile: 0,
    portraitBP: 600,
    tablet: 768,
    landscapeBP: 1000,
    desktop: 1200,
    breakpointsOrder: ["mobile", "portraitBP", "tablet", "landscapeBP", "desktop"],
  });

  return Vue.extend({
    router,
    store,
    i18n,
    render: h => h(require("./App.vue").default),
  });
}
export function createApp() {
  Vue.config.productionTip = false;
  return new (getApp())();
}
